import React from 'react';

import { QuickFAQ } from '@/types/ContactBlock';

import { FaqsList, FaqItemWrapper, FaqItem } from './ContactBlock.styles';

type Props = {
  faqs: QuickFAQ[];
  locale: string;
};

const supportPathMap: Record<string, string> = {
  en: 'support',
  fr: 'aide',
  nl: 'hulp',
};

const generatePageSlug = (faq: QuickFAQ, locale: string): string | null => {
  if (faq.__typename === 'ContentfulFaqMainTheme') {
    const slug = faq?.support_theme_page_type?.[0]?.page?.[0]?.slug;
    return slug ? `/${locale}/${slug}` : null;
  }

  const supportPath = supportPathMap[locale];
  const slug = faq?.page?.[0]?.slug;

  return slug && supportPath ? `/${locale}/${supportPath}/${slug}` : null;
};

const QuickFaqs: React.FC<Props> = (props) => {
  const { faqs, locale } = props;

  if (!faqs?.length) {
    return null;
  }

  return (
    <FaqsList>
      {faqs.map((faq) => {
        const faqLink = generatePageSlug(faq, locale);

        if (!faqLink) {
          return null;
        }

        return (
          <FaqItemWrapper key={faq.title}>
            <FaqItem href={faqLink}>{faq.title}</FaqItem>
          </FaqItemWrapper>
        );
      })}
    </FaqsList>
  );
};

export default QuickFaqs;
